module.exports = __webpack_public_path__ + "static/media/MSR.32b1e88a.png";